import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicTableComponent from "./DataTable/BasicTableComponent";
import BorderedTableComponent from "./BorderedTable/BorderedTableComponent";

const TablePage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox title={"Table"} description={""} />
      <Divider light />
      <BasicTableComponent />
      <BorderedTableComponent />
    </Paper>
  );
};

export default TablePage;
